import { globalConfig, courseStore } from './globalStore'
import config from '../api/config'
import i18n from '../languages/index';
import device from "current-device";

export default {

}

export const buildDate = __BUILD_DATE__;

export function isAvailableString (text) {
    return text && text.length > 0
}

export function isOnlySymbolString (text) {
    // 使用正则表达式匹配所有非标点符号的字符，包括中文、英文、数字和空白字符
    let nonSymbolPattern = /[\p{L}\p{N}]/u;
    // 如果字符串中包含任何非标点符号的字符，则返回false
    return !nonSymbolPattern.test(text) && text.length > 0;
}

//邮箱验证
export function emailVerification (email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

//是否是移动设备访问，包括平板
export function isMobileDevice () {
    return isPhoneDevice() || isPadDevice();
}

//是否是手机
export function isPhoneDevice () {
    return window.innerWidth <= 750 || device.mobile();
}

//是否是平板
export function isPadDevice () {
    return (window.innerWidth > 750 && window.innerWidth < 1100) ||  device.tablet();
}

//是否是电脑版
export function isDeskTopDevice () {
    return window.innerWidth > 1100 || device.desktop();
}

//是否是安卓 app
export function isAndroidApp () {
    return globalConfig().ref == "gapp" && getOS() == "Android"
}

//精简语言缩写
export function languageFilter(languageStr) {
    let lang = "en";
    let language = languageStr.toLowerCase()
    if (language && language.length > 0) {
        //繁体区分
        if (language == "zh-hant" || language == "zh-tw" || language == "zh-hk" || language == "zh-mo") {
            lang = "zh-Hant"
        } else {
            let arr = language.split('-');
            lang = arr[0]
        }
    }
    //过滤
    let allList = config.allList;
    if (allList.includes(lang) ) {
        return lang
    } else {
        return "en"
    }
}

//白牌判断，是否是spealpal.ai域名
export function isSpeakpalDomain () {
    if (window.location.hostname.endsWith('germantutor.ai') || window.location.hostname.endsWith('localhost')) {
        return true
    } else {
        return false
    }
}

//白牌判断，是否是组织推广链接
export function isOrgURL () {
    const params = new URLSearchParams(window.location.search);
    if (params.has('org')) {
        const orgValue = params.get('org');
        return true
    } else {
        return false
    }
}

//打开外部url
export function openUrl (url, target = "_blank") {
    var newWindow = window.open(url, target)
    if (target == "_blank" && (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined')) {
        // 浏览器阻止了弹出窗口，你可以在这里提供一些提示或处理逻辑
        window.open(url, "_self")
    }
}

//跳转官网
export function openHomeUrl(path, target = "_blank", query = null) {
    let gConfig = globalConfig()
    let url = config.home + path + "/" + gConfig.langCode

    let _query = "?r=force"
    if (gConfig.ref && gConfig.ref != "") {
        _query = _query + "&ref=" + gConfig.ref
    }
    if (query && query != "") {
        if (_query.length > 0) {
            _query = _query + "&" + query
        } else {
            _query = "?" + query
        }
    }
    openUrl(url + _query, target)
}

//获取浏览器操作系统
export function getOS () {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipod') !== -1 || userAgent.indexOf('ipad') !== -1 ){
        return 'iOS';
    } else if (userAgent.indexOf('android') !== -1) {
        return 'Android';
    } else if (userAgent.indexOf('linux') !== -1) {
        return 'Linux';
    } else if (userAgent.indexOf('macintosh') !== -1 || userAgent.indexOf('mac os x') !== -1) {
        return 'Mac';
    } else if (userAgent.indexOf('windows') !== -1) {
        return 'Windows';
    } else {
        return 'Unknown';
    }
}

//获取浏览器名称
export function getBrowserName() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') !== -1) {
        return 'Chrome';
    } else if (userAgent.indexOf('firefox') !== -1) {
        return 'Firefox';
    } else if (userAgent.indexOf('safari') !== -1) {
        return 'Safari';
    } else if (userAgent.indexOf('opera') !== -1 || userAgent.indexOf('opr') !== -1) {
        return 'Opera';
    } else if (userAgent.indexOf('edge') !== -1 || userAgent.indexOf('edg') !== -1) {
        return 'Edge';
    } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
        return 'Internet Explorer';
    } else {
        return 'Unknown';
    }
}

//是否是低版本
export function isIOS12OrEarlier() {
    var userAgent = navigator.userAgent;
    var match = userAgent.match(/OS (\d+)_?(\d+)?_?(\d+)?/);
    
    if (match) {
        var major = parseInt(match[1], 10);
        return major <= 12; // 判断 iOS 版本是否 ≤ 12
    }
    return false; // 不是 iOS 设备，返回 false
}

//访问用户选择的界面语言(默认英文)
export function getLanguage () {
    const config = globalConfig()
    let browserLanguage = config.langCode
    if (!browserLanguage || browserLanguage.length == 0) {
        browserLanguage = navigator.language || navigator.userLanguage
    }
    config.langCode = languageFilter(browserLanguage)
    return config.langCode
}


//更新html语言设置
export function changeLanguage(langCode) {
    //设置组件语言
    // console.log("changeLanguage:", langCode)
    //  useLocale(zhCn) // 注意这里用 useLocale
    //设置自己的
    let lang = languageFilter(langCode)
    // 获取html元素
    const htmlElement = document.querySelector('html');
    htmlElement.setAttribute('lang', lang);
    //更新本地缓存语言
    const config = globalConfig()
    config.langCode = lang
    //设置语言
    i18n.global.locale.value = lang.replace(/-/g, "_")
    
}

//通过路径获取路径中是否已经指定语言
export function getLangByPath(path) {
    let allList = config.allList;
    const regex = /\/([\w-]+)$/; // 匹配最后一个单词字符组成的字符串
    const match = path.match(regex);
    let lastPath = match ? match[1] : null;
    if (lastPath) {
        let isExist = allList.includes(lastPath);
        if (!isExist) {
            lastPath = null
        }
    }
    return lastPath
}


//增加多语言hreflang
export function changeHrefLang (to) {
    let allList = config.allList;
    let path = to.path;
    let queryString = Object.keys(to.query).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(to.query[key])}`).join('&');
    if (queryString && queryString.length > 0) {
        queryString = "?" + queryString;
    }
    //检测path是否已经指定了语言，如果已经指定，则移除语言版本
    let lang = getLangByPath(path);
    if (lang) {
        path = path.replace(/\/[\w-]+$/, '');
    }
    let url = window.location.origin + path;
    //添加主链接
    var linkElement = document.getElementById('canonical_link')
    if (linkElement) {
        linkElement.href = url + queryString;
    } else {
        linkElement = document.createElement('link');
        linkElement.rel = 'canonical';
        linkElement.id = 'canonical_link';
        linkElement.href = url + queryString;
        // 将 link 元素添加到 head 元素中
        document.head.appendChild(linkElement);
    }
    //添加自引用链接
    var selfLinkElement = document.getElementById('alternate_self')
    if (selfLinkElement) {
        selfLinkElement.href = url + queryString;
    } else {
        selfLinkElement = document.createElement('link');
        selfLinkElement.rel = 'alternate';
        selfLinkElement.hreflang = getLanguage();
        selfLinkElement.id = 'alternate_self';
        selfLinkElement.href = url + queryString;
        // 将 link 元素添加到 head 元素中
        document.head.appendChild(selfLinkElement);
    }
    
    //添加其他链接
    allList.forEach(element => {
        var linkElement = document.getElementById('alternate_' + element.replace("-", "_"))
        if (linkElement) {
            linkElement.href = url + "/" + element + queryString;
        } else {
            linkElement = document.createElement('link');
            linkElement.rel = 'alternate';
            linkElement.hreflang = element;
            linkElement.id = 'alternate_' + element.replace("-", "_");
            linkElement.href = url + "/" + element + queryString;
            // 将 link 元素添加到 head 元素中
            document.head.appendChild(linkElement);
        }
    });
}

//更改meta信息
export function changeSeoMeta(title, keywords, description) {
    let metaElement = (key, name) => {
        const existingMeta = document.querySelector(`meta[${key}="${name}"]`);
        if (existingMeta) {
            return existingMeta
        } else {
            const meta = document.createElement('meta');
            meta.setAttribute(key, name);
            const firstChild = document.head.firstChild; // 获取头部的第一个子元素
            document.head.insertBefore(meta, firstChild); // 将新创建的 meta 元素插入到第一个子元素之前
            return meta
        }
    }
    if (globalConfig().isFromOrg && globalConfig().orgInfo) {
        //使用第三方的标题
        document.title = globalConfig().orgInfo.logo_name
        //使用第三方的favicon
        const rels = ['icon', 'shortcut icon', 'apple-touch-icon'];

        rels.forEach(rel => {
            let link = document.querySelector(`link[rel='${rel}']`);
            if (!link) {
                link = document.createElement('link');
                link.rel = rel;
                document.head.appendChild(link);
            }
            link.href = globalConfig().orgInfo.logo_url;
        });
    } else {
        document.title = title
    }
    metaElement('name', "description").setAttribute("content", description)
    metaElement('name', "keywords").setAttribute("content", keywords)
    //设置og
    metaElement('property', "og:title").setAttribute("content", title)
    metaElement('property', "og:description").setAttribute("content", description)
    metaElement('property', "og:image").setAttribute("content", window.location.origin + "/images/call_logo.png")
    metaElement('property', "og:url").setAttribute("content", window.location.href)
    metaElement('property', "og:site_name").setAttribute("content", "GermanTutor")
    metaElement('property', "og:type").setAttribute("content", "website")
    //设置twitter卡片
    metaElement('name', "twitter:title").setAttribute("content", title)
    metaElement('name', "twitter:description").setAttribute("content", description)
    metaElement('name', "twitter:image").setAttribute("content", window.location.origin + "/images/call_logo.png")
    metaElement('name', "twitter:image:src").setAttribute("content", window.location.origin + "/images/call_logo.png")
    metaElement('name', "twitter:card").setAttribute("content", "summary")
    metaElement('name', "twitter:site").setAttribute("content", window.location.href)
}

export function setInputValue(val) {
    courseStore().setInputValue(val)
    return val;
}


export function downloadFile(option, complete = () => {}) {
    let filename = new URL(option.url).pathname.split('/').pop();
    if (option.filename) {
        filename = option.filename;
    }
    fetch(option.url)
        .then(res => res.blob())
        .then(blob => {
            const link = document.createElement('a');
            const blobUrl = URL.createObjectURL(blob);
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }).finally(() => {
            complete && complete();
        });
}

export function saveToDesktop(fileName, url) {
    const explorer = navigator.userAgent.toLowerCase();
    let data = '[InternetShortcut]'+'\n'+'URL='+ url + "\r\nIconFile=https://talk.germantutor.ai/favicon.ico";
    if (explorer.indexOf("trident") > 0) {
        // IE 5+ 浏览器
        const wss = new ActiveXObject("WScript.Shell");
        const desktopUrl = wss.SpecialFolders("Desktop");
        const fso = new ActiveXObject("Scripting.FileSystemObject");
        const tf = fso.CreateTextFile(desktopUrl + "\\" + fileName + ".url", true);
        tf.Write(data);
        tf.Close();
    } else {
        // fireFox chrome 浏览器
        const urlObj = window.URL || window.webkitURL || window;
        const blob = new Blob([data]);
        const link = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
        link.href = urlObj.createObjectURL(blob);
        link.download = fileName + ".url";
        saveClick(link);
    }

    function saveClick(obj) {
        const e = document.createEvent("MouseEvents");
        e.initMouseEvent(
            "click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null
        );
        obj.dispatchEvent(e);
    }
}
